<template>
	<nk-page commercialAccess="Sale">
		<div class="h-100 d-flex flex-column">
			<div class="form-container">
				<div class="container-fluid">
					<div class="row nk-card">
						<div v-if="!sortedFloatings.length" class="col-12">
							<p class="alert alert-secondary mb-0">{{ $t('sale.product-request.m.no-product-floating-found') }}</p>
						</div>
						<div v-for="(floating, index) in sortedFloatings" :key="floating.id" class="col-12 col-md-4">
							<nk-col-form-group :label="floating.name + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
								<nk-dropdown v-if="floating.valueType === 'Selective'" v-model="floatingValues[floating.id]" :data="getSortedValues(floating)" :options="getDropdownOptions()" :tabindex="100 + index" startup></nk-dropdown>
								<nk-date v-else-if="floating.dataType === 'Date'" v-model="floatingValues[floating.id]" :options="getDateOptions()" :tabindex="100 + index" startup></nk-date>
								<nk-input v-else v-model="floatingValues[floating.id]" :options="getInputOptions(floating.dataType)" :tabindex="100 + index" startup></nk-input>
							</nk-col-form-group>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script>
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import emptyId from '~/statics/empty-id'

	export default {
		name: 'product-floating-combination',
		modal: {
			size: 'md',
			stateUID: 'product-floating-combination',
			helpTag: 'ProductFloatingCombination'
		},
		props: {
			options: { type: Object },
			data: { type: Array, default: null },
		},
		data() {
			return {
				floatingValues: {},
				saveButton: {
					title: this.$t('accept'),
					shortcut: $sc.find('save'),
					icon: 'check',
					isPrimary: true,
					handle: () => {
						this.save()
					}
				},
			}
		},
		computed: {
			...mapGetters({
				productFloatings: 'productFloatings/all',
			}),
			sortedFloatings() {
				return [...(this.productFloatings || [])].sort((a, b) => a.displayOrder - b.displayOrder)
			},
		},
		mounted() {
			this.fillFormFromData()
			this.prepareWindow(this.$t('sale.product-floating.combination-title'), [this.saveButton])
		},
		methods: {
			fillFormFromData() {
				if (!this.data?.length)
					return

				this.data.forEach((item) => {
					const floating = this.sortedFloatings.find(x => x.id === item.productFloatingId)
					if (!floating)
						return

					if (floating.valueType === 'Selective') {
						const value = this.getSortedValues(floating).find(x => x.id === item.productFloatingValueId)
						if (value)
							this.floatingValues[floating.id] = value
					}
					else {
						this.floatingValues[floating.id] = item.productFloatingValueTitle
					}
				})
			},
			getSortedValues(floating) {
				return [...(floating.productFloatingValues || [])].sort((a, b) => a.displayOrder - b.displayOrder)
			},
			getDropdownOptions() {
				return {
					rowIdentifier: 'id',
					searchable: true,
					required: false,
					placeholder: this.$t('search'),
					display: (item) => item.title,
					searchableFields: ['title'],
				}
			},
			getInputOptions(dataType) {
				switch (dataType) {
					case 'Numeric':
						return { mode: 'strnumber' }
					default:
						return { mode: 'text' }
				}
			},
			getDateOptions() {
				return {
					pickerEnabled: true,
				}
			},
			getManualValueText(value) {
				if (value == null)
					return ''

				if (typeof value === 'string')
					return value.trim()

				if (typeof value === 'object' && value.date)
					return String(value.date).trim()

				return String(value).trim()
			},
			prepareResult() {
				const result = []

				this.sortedFloatings.forEach((floating) => {
					const value = this.floatingValues[floating.id]

					if (floating.valueType === 'Selective') {
						if (!value || !value.id)
							return

						result.push({
							productFloatingId: floating.id,
							productFloatingValueId: value.id,
							productFloatingValueTitle: value.title,
							productFloatingName: floating.name,
							productFloatingType: floating.valueType,
						})
					}
					else {
						const text = this.getManualValueText(value)
						if (!text)
							return

						result.push({
							productFloatingId: floating.id,
							productFloatingValueId: emptyId,
							productFloatingValueTitle: text,
							productFloatingName: floating.name,
							productFloatingType: floating.valueType,
						})
					}
				})

				return result
			},
			save() {
				this.resolve(this.prepareResult())
			},
		},
	}
</script>

<style></style>
